import { Service } from './index'

const stripePricingTable: Service = {
  init() {
    const script = document.createElement('script')
    script.src = 'https://js.stripe.com/v3/pricing-table.js'
    script.async = true

    document.head.appendChild(script)

    return new Promise((resolve) => {
      script.onload = () => resolve()
    })
  },
  loaded: () => {
    return customElements.get('stripe-pricing-table') !== undefined
  },
  instance: () => undefined,
}
export default stripePricingTable
